module.exports = __webpack_public_path__ + "bade94b30e037e4377303c6bc4e1774f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/x.png
// module id = 227
// module chunks = 0